// extracted by mini-css-extract-plugin
export default {"section":"Disclaimer_section__PqazG","wrapper":"Disclaimer_wrapper__C4RdS"};